import $ from 'zepto';
import {
  fileUploaderClass,
  fileUploaderSelector,
} from '../../utils/constants/classes';

export default class FileUploader {
  constructor(config) {
    this.files = [];
    this.id = config.id;
    this.accessibleDeleteFileText = '';
    this.getFiles = this.getFiles.bind(this);
    this.getFilesObject = this.getFilesObject.bind(this);
    this.onClickDeleteItem = this.onClickDeleteItem.bind(this);
    this.buildCustomFilesList = this.buildCustomFilesList.bind(this);
  }

  /**
   * Add change event to the input file selector
   *
   * @param {(HTMLElement|Zepto)} inputFile
   */
  initInputFile(inputFile) {
    $(inputFile).on('change', () => {
      this.buildCustomFilesList(inputFile);
      inputFile.val('');
    });
  }

  /**
   * Create custom list of files to upload
   *
   * @param {HTMLElement} inputFile
   * @returns {(HTMLElement|Zepto)}
   */
  buildCustomFilesList(inputFile) {
    const $fileUploaderContainer = inputFile.closest(fileUploaderSelector);

    // Get or create UL element
    const $ulElement = $fileUploaderContainer.find('ul.xvx-list').length > 0
      ? $fileUploaderContainer.find('ul.xvx-list')
      : $('<ul class="xvx-list xvx-list--no-style xvxs-top-5vr"></ul>');

    if ($ulElement.children().length > 0) {
      $ulElement.children().remove();
    }

    if (inputFile.data('delete-label')) {
      this.accessibleDeleteFileText = inputFile.data('delete-label');
    }

    this.sanitizeFilesArray(inputFile.get(0).files);

    this.files.forEach((element) => {
      const fileItem = element;
      const $liElement = $('<li class="xvx-list__item xvxs-top-4vr"></li>');
      const $textIconDivContainer = $(`<div class="${fileUploaderClass}__item"></div>`);
      const $textIconDiv = $('<div class="xvx-text-icon xvx-text-icon-size--4vr"></div>');

      $textIconDiv.append(FileUploader.createIconItem(fileItem.type));
      $textIconDiv.append(FileUploader.createFileItemName(fileItem.name));
      $textIconDivContainer.append($textIconDiv);
      $textIconDivContainer.append(this.createDeleteFileButton(fileItem.name));
      $liElement.append($textIconDivContainer);
      $ulElement.append($liElement);
    });

    $fileUploaderContainer.append($ulElement);
  }

  /**
   * Update this.files array by filtering filesArray repeated values
   *
   * @param {array} filesArray
   */
  sanitizeFilesArray(filesArray) {
    Object.keys(filesArray).forEach((index) => {
      const isInArray = this.files.find((filesItem) => filesItem.name === filesArray[index].name);
      if (!isInArray) {
        this.files.push(filesArray[index]);
      }
    });
  }

  /**
   * creates icon structure with specific icon class
   *
   * @param {string} fileType
   * @retunrs {(HTMLElement|Zepto)} div with a span element
   */
  static createIconItem(fileType) {
    const $iconContainer = $('<div class="xvx-text-icon__icon"></div>');
    const $iconElement = $('<span class="xvx-icon xvx-icon-size--4vr"></span>');
    const imageType = fileType.split('/')[0];

    if (imageType === 'application') {
      $iconElement.addClass('xvx-icon--type-document');
    } else {
      $iconElement.addClass('xvx-icon--type-image');
    }

    return $iconContainer.append($iconElement);
  }

  /**
   * Create paragraph with file name
   *
   * @param {string} fileName
   * @returns {(HTMLElement|Zepto)} paragraph element
   */
  static createFileItemName(fileName) {
    const fileItemClass = 'xvxp-left-2vr xvx-font-copy-legal xvx-text-icon__text xvx-text-truncate-nowrap xvx-text-color-grey-700'; // eslint-disable-line max-len

    return $(`<p class="${fileItemClass}">${fileName}</p>`);
  }

  /**
   * Create delete button element
   *
   * @param {string} fileName
   * @returns {(HTMLElement|Zepto)} button with a span element
   */
  createDeleteFileButton(fileName) {
    const $deleteFileButton = $('<button/>', {
      id: fileName,
      class: `${fileUploaderClass}__item-delete`,
      type: 'button',
    });
    const $deleteFileContent = $('<span/>', {
      class: 'xvx-screen-reader-only',
      html: `${this.accessibleDeleteFileText} ${fileName}`,
    });

    $deleteFileButton.on('click', this.onClickDeleteItem);
    return $deleteFileButton.append($deleteFileContent);
  }

  /**
   * Removes list elements from the DOM and
   * removes value from array
   *
   * @param {e} event
   */
  onClickDeleteItem(e) {
    const $itemToDelete = $(e.target);
    const $parentUl = $itemToDelete.closest('ul.xvx-list');

    const valuePositionToDelete = this.files.findIndex((filesItem) => filesItem.name === $itemToDelete.attr('id'));
    if (valuePositionToDelete >= 0) {
      this.files.splice(valuePositionToDelete, 1);

      $itemToDelete.closest('.xvx-list__item').remove();
      if (!$parentUl.children().length) {
        $parentUl.remove();
      }
    }
  }

  /**
   * Returns an object with files buffer from
   * the input file native data
   *
   * @param {String} name
   * @returns {object}
   */
  getFilesObject() {
    const sealedFiles = Object.seal([].concat(this.files));
    const files = Object.create(sealedFiles);
    return Object.freeze(files);
  }

  /**
   * Returns object from getFilesObject
   *
   */
  getFiles() {
    return this.getFilesObject();
  }
}
